import ProtectedRoute from 'components/ProtectedRoute'
import React from 'react'
import { Switch } from 'react-router-dom'
import Landing from './Landing'
import View from './View'

const Users: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Users"
        exact
        path="/users"
        component={Landing}
      />
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="UsersByIdentifier"
        exact
        path="/users/:identifier"
        component={View}
      />
    </Switch>
  )
}

export default Users
